import '../css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { changeLogId, checkLogin } from '../../store';
import { SyncLoader } from "react-spinners";
import Message from '../common/message';

import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

function Token() {
    let dark = useSelector((state) => state.Darkmode.value);

    const [reload, setReload] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [message, setMessage] = useState({ code: -1, msg: "" });

    // (1) 서버에서 받은 원본 데이터들
    const [data, setData] = useState([]);       // /api/wallet-token 결과
    const [dataList, setDataList] = useState([]); // /api/wallet-network 결과

    // (2) 모달 관리
    const [createModal, setCreateModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [clickId, setClickId] = useState([]);

    const darkname = dark ? 'dark' : "";

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/');
            } else {
                dispatch(checkLogin(true));
            }
        } else {
            dispatch(checkLogin(false));
            navigate('/');
        }
    }, []);

    // (3) 데이터 조회
    useEffect(() => {
        ListData();
        UpgradeData();
    }, [reload]);

    // wallet-token 조회
    const UpgradeData = async () => {
        setSpinner(true);
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/wallet-token');
            let tmp = response.data;
            console.log(tmp);
            if (tmp?.code == 1000) {
                setData(tmp?.data?.tokens ?? []);
            }
            setSpinner(false);
        } catch (error) {
            console.error(error);
            setSpinner(false);
        }
    };

    // wallet-network 조회
    const ListData = async () => {
        setSpinner(true);
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/wallet-network');
            let tmp = response.data;
            if (tmp?.code == 1000) {
                console.log(tmp);
                setDataList(tmp?.data?.network ?? []);
            }
            setSpinner(false);
        } catch (error) {
            console.log(error);
            setSpinner(false);
        }
    };

    // (4) select 박스 선택된 currency
    const [selectedCurrency, setSelectedCurrency] = useState("all");

    // select 변경 핸들러
    const handleSelectChange = (e) => {
        setSelectedCurrency(e.target.value);
    };

    // (5) 데이터 필터링
    const filteredData = selectedCurrency === "all"
        ? data
        : data.filter((item) => item.ti_network.toLowerCase() === selectedCurrency);

    return (
        <div className="main">
            <Message message={message} />
            {createModal && (
                <CreateModal
                    darkname={darkname}
                    setModal={setCreateModal}
                    setReload={setReload}
                    dataList={dataList}
                />
            )}
            {updateModal && (
                <UpdateModal
                    darkname={darkname}
                    setModal={setUpdateModal}
                    clickId={clickId}
                    setReload={setReload}
                />
            )}
            <div className={`main-box ${darkname}`}>
                <div className="member-1">
                    <div className="modal-btn" onClick={() => setCreateModal(true)}>
                        등록
                    </div>
                </div>

                <div className='password-1' style={{ width: "200px", marginTop: "20px", padding: "0", paddingRight: "5px" }}>
                    {/* (6) select 박스: '전체' + dataList 의 symbol */}
                    <select value={selectedCurrency} onChange={handleSelectChange}
                        style={{ width: "100%", border: "none", outline: "none", padding: "7px 10px", borderRadius: "5px" }}>
                        <option value="all">전체</option>
                        {dataList.map((a, i) => (
                            <option key={i} value={a.symbol}>
                                {a.symbol}
                            </option>
                        ))}
                    </select>
                </div>

                <div className={`member-2 ${darkname}`}>
                    <div className={`table-head ${darkname}`}>
                        <div style={{ width: "10%", minWidth: "70px" }}>no.</div>
                        <div style={{ width: "10%", minWidth: "150px" }}>네트워크 이름</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>토큰 이름</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>심볼</div>
                        <div style={{ width: "30%", minWidth: "400px" }}>주소</div>
                        <div style={{ width: "15%", minWidth: "120px" }}>소수점 자리수</div>
                        <div style={{ width: "15%", minWidth: "150px" }}>설명</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>타입</div>
                        <div style={{ width: "20%", minWidth: "250px" }}>아이콘</div>
                        <div>비고</div>
                    </div>
                    <div className="table-body" style={{ minHeight: "600px" }}>
                        {spinner ? (
                            <div className="spinner-modal">
                                <SyncLoader color="#003577" />
                            </div>
                        ) : filteredData.length === 0 ? (
                            <div className="data-nofound">
                                <img src="/img/img_nofound.png" alt="nofound-light" />
                                <img
                                    src="/img/img_nofound_dark.svg"
                                    style={{ display: "none" }}
                                    alt="nofound-dark"
                                />
                                <p>NO RECORDS FOUND</p>
                            </div>
                        ) : (
                            <>
                                {filteredData.map((a, i) => (
                                    <MemberItem
                                        key={i}
                                        item={a}
                                        darkname={darkname}
                                        dark={dark}
                                        setUpdateModal={setUpdateModal}
                                        setClickId={setClickId}
                                        setReload={setReload}
                                    />
                                ))}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div >
    );
}

function MemberItem({ item, darkname, dark, setUpdateModal, setClickId, setReload }) {
    const onClickData = () => {
        setClickId(item);
        setUpdateModal(true)
    }

    const onSubmitDelete = async () => {
        await axios.post(process.env.REACT_APP_API + "/api/wallet-token/delete", {
            id: item.no
        }, {
            // headers: { 'Content-Type': 'multipart/form-data' },
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                setReload(e => !e)
            }
            else {
                // setMessage({ msg: "등록에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    return (
        <>
            <div className={`table-body-tr ${darkname}`}>
                <div className='td' style={{ width: "10%", minWidth: "70px" }}>{item.no}</div>
                <div className='td' style={{ width: "10%", minWidth: "150px" }}>{item.ti_network}</div>
                <div className='td' style={{ width: "10%", minWidth: "100px" }}>{item.ti_name}</div>
                <div className='td' style={{ width: "10%", minWidth: "100px" }}>{item.ti_symbol}</div>
                <div className='td' style={{ width: "30%", minWidth: "400px" }}>
                    <div className="table-overflow-hidden">
                        {item.ti_mintaddress}
                    </div>
                </div>
                <div className='td' style={{ width: "15%", minWidth: "120px" }}>{item.ti_decimal}</div>
                <div className='td' style={{ width: "15%", minWidth: "150px" }}>{item.ti_description}</div>
                <div className='td' style={{ width: "10%", minWidth: "100px" }}>{item.ti_type}</div>
                <div className='td' style={{ width: "20%", minWidth: "250px" }}>
                    <div className="table-overflow-hidden" style={{ paddingRight: "5px" }}>
                        {item.ti_icon}
                    </div>
                    <img src={item.ti_icon} style={{ width: "28px" }} />
                </div>
                <div className='td' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                    <div className="upgrade-btn" onClick={() => onClickData()} style={{ backgroundColor: "#003577", color: "#fff" }}>수정</div>
                    <div className="upgrade-btn" onClick={() => onSubmitDelete()}>삭제</div>
                </div>
            </div>
        </>
    )
}

function CreateModal({ darkname, setModal, setReload, dataList }) {
    // 1) 상태
    const [formData, setFormData] = useState({
        networkGroup: "ton", // 기본값
        tokenName: "",
        tokenSymbol: "",
        tokenAddress: "",
        tokenDecimals: "",
        tokenDescription: "",
        tokenType: "coin", // 기본 coin
        tokenIcon: "",
    });

    // 아이콘 업로드 상태
    const [iconFile, setIconFile] = useState(null);
    const [iconPreview, setIconPreview] = useState(null);
    const hiddenFileInputRef = useRef(null);

    // 소문자 알파벳만 허용
    const forceLowerCaseAlpha = (value) =>
        value.toLowerCase().replace(/[^a-z]/g, "");

    // ========== input onChange ==========
    const onChangeInput = (e) => {
        let { name, value } = e.target;
        // (A) 토큰이름/토큰심볼 => 소문자
        if (name === "tokenName" || name === "tokenSymbol") {
            value = forceLowerCaseAlpha(value);
        }
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // ========== select onChange ==========
    const onChangeSelect = (e) => {
        const { name, value } = e.target;
        if (name === "tokenType") {
            // coin -> tokenAddress = ""
            setFormData((prev) => ({
                ...prev,
                tokenType: value,
                tokenAddress: value === "coin" ? "" : prev.tokenAddress,
            }));
        } else if (name === "networkGroup") {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    // ========== 아이콘 업로드 버튼 ==========
    const handleIconUploadClick = () => {
        if (hiddenFileInputRef.current) {
            hiddenFileInputRef.current.click();
        }
    };

    // ========== 파일 선택 처리 ==========
    const handleIconFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setIconFile(file);
        // 미리보기
        const previewUrl = URL.createObjectURL(file);
        setIconPreview(previewUrl);

        // tokenIcon에 파일명 세팅
        setFormData((prev) => ({ ...prev, tokenIcon: file.name }));
    };

    // ========== X 버튼 (아이콘 삭제) ==========
    const handleRemoveIcon = () => {
        setIconFile(null);
        setIconPreview(null);
        setFormData((prev) => ({ ...prev, tokenIcon: "" }));
        if (hiddenFileInputRef.current) {
            hiddenFileInputRef.current.value = "";
        }
    };

    // ========== onSubmit (유효성 검사 + multipart/form-data) ==========
    const onSubmit = async () => {
        // 1) 토큰 이름 필수
        if (!formData.tokenName) {
            alert("토큰 이름(소문자)은 필수값입니다.");
            return;
        }
        // 2) 토큰 심볼 필수
        if (!formData.tokenSymbol) {
            alert("토큰 심볼(소문자)은 필수값입니다.");
            return;
        }
        // 3) tokenType === "token" 이면 토큰 주소 필수
        if (formData.tokenType === "token" && !formData.tokenAddress) {
            alert("토큰 타입이 token이면 토큰 주소가 필수값입니다.");
            return;
        }
        // 4) 토큰 소수점 자리수 => 양의 정수만 허용
        const decimalValue = Number(formData.tokenDecimals);
        if (!formData.tokenDecimals) {
            alert("토큰 소수점 자리수를 입력해 주세요.");
            return;
        }
        if (isNaN(decimalValue) || decimalValue <= 0 || !Number.isInteger(decimalValue)) {
            alert("토큰 소수점 자리수는 1 이상의 정수만 입력 가능합니다.");
            return;
        }

        try {
            // 파일 + 텍스트 필드를 함께 전송
            const form = new FormData();
            form.append("ti_network", formData.networkGroup);
            form.append("ti_name", formData.tokenName);
            form.append("ti_symbol", formData.tokenSymbol);
            form.append("ti_mintaddress", formData.tokenAddress);
            form.append("ti_decimal", formData.tokenDecimals);
            form.append("ti_description", formData.tokenDescription);
            form.append("ti_type", formData.tokenType);
            // 파일이 있으면
            if (iconFile) {
                form.append("file", iconFile);
            }

            const response = await axios.post(
                process.env.REACT_APP_API + "/api/wallet-token",
                form,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            const tmp = response.data;
            if (tmp?.code === 1000) {
                setModal(false);
                setReload((prev) => !prev);
            } else {
                alert(tmp?.msg || "등록에 실패했습니다.");
            }
        } catch (error) {
            console.error(error);
            alert("등록 중 오류가 발생했습니다.");
        }
    };

    return (
        <div className="modal">
            <div className="modal-box">
                <div className="modal-1" style={{ width: "500px" }}>
                    <div className="modal-1-header">토큰 등록</div>

                    <div style={{ marginBottom: "30px" }}>
                        {/* 네트워크 이름 (select) */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                네트워크 이름
                                <InfoIcon
                                    tooltipId="tooltip-networkGroup"
                                    content="토큰이 발행된 네트워크를 선택해 주세요"
                                />
                            </div>
                            <div
                                className={`password-1 ${darkname}`}
                                style={{ padding: "0", paddingRight: "5px" }}
                            >
                                <select
                                    name="networkGroup"
                                    value={formData.networkGroup}
                                    onChange={onChangeSelect}
                                    style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        padding: "7px 10px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    {dataList.map((a, i) => (
                                        <option key={i} value={a.symbol}>
                                            {a.symbol}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* 토큰 이름 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                토큰 이름
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenName"
                                    value={formData.tokenName}
                                    onChange={onChangeInput}
                                    placeholder="토큰 이름"
                                />
                            </div>
                        </div>

                        {/* 토큰 심볼 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                토큰 심볼
                                <InfoIcon
                                    tooltipId="tooltip-tokenSymbol"
                                    content="미니앱 지갑에서 표시되는 토큰의 심볼"
                                />
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenSymbol"
                                    value={formData.tokenSymbol}
                                    onChange={onChangeInput}
                                    placeholder="토큰 심볼"
                                />
                            </div>
                        </div>

                        {/* 토큰 주소 (tokenType==="coin" 이면 disabled) */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                토큰 주소
                                <InfoIcon
                                    tooltipId="tooltip-tokenAddress"
                                    content="토큰의 고유 주소입니다. (코인이면 비활성)"
                                />
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenAddress"
                                    value={formData.tokenAddress}
                                    onChange={onChangeInput}
                                    placeholder="토큰 주소"
                                    disabled={formData.tokenType === "coin"}
                                />
                            </div>
                        </div>

                        {/* 토큰 소수점 자리수 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                토큰 소수점 자리수
                                <InfoIcon
                                    tooltipId="tooltip-tokenDecimals"
                                    content="토큰의 소수점 자릿수를 입력하세요 (양의 정수)"
                                />
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenDecimals"
                                    value={formData.tokenDecimals}
                                    onChange={onChangeInput}
                                    placeholder="토큰 소수점 자리수 (숫자)"
                                />
                            </div>
                        </div>

                        {/* 토큰 설명 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                토큰 설명
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenDescription"
                                    value={formData.tokenDescription}
                                    onChange={onChangeInput}
                                    placeholder="토큰 설명"
                                />
                            </div>
                        </div>

                        {/* 토큰 타입 (coin/token) */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                토큰 타입
                                <InfoIcon
                                    tooltipId="tooltip-tokenType"
                                    content="네트워크 코인인지, 서브 토큰인지 선택 (coin/token)"
                                />
                            </div>
                            <div
                                className={`password-1 ${darkname}`}
                                style={{ padding: "0", paddingRight: "5px" }}
                            >
                                <select
                                    name="tokenType"
                                    value={formData.tokenType}
                                    onChange={onChangeSelect}
                                    style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        padding: "7px 10px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <option value="coin">coin</option>
                                    <option value="token">token</option>
                                </select>
                            </div>
                        </div>

                        {/* 아이콘 업로드 & 미리보기 & X버튼 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                토큰 아이콘
                                <InfoIcon
                                    tooltipId="tooltip-tokenIcon"
                                    content="토큰 로고 아이콘 이미지"
                                />
                            </div>
                            <div
                                className={`password-1 ${darkname}`}
                                style={{ display: "flex", alignItems: "center", gap: "8px" }}
                            >
                                <input
                                    name="tokenIcon"
                                    value={formData.tokenIcon}
                                    onChange={onChangeInput}
                                    placeholder="토큰 아이콘 URL"
                                    style={{ flex: 1 }}
                                />
                                {/* 업로드 버튼 */}
                                <div
                                    onClick={() => hiddenFileInputRef.current.click()}
                                    style={{
                                        backgroundColor: "#eee",
                                        borderRadius: "5px",
                                        padding: "5px 10px",
                                        cursor: "pointer",
                                    }}
                                >
                                    아이콘 업로드
                                </div>
                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={hiddenFileInputRef}
                                    style={{ display: "none" }}
                                    onChange={handleIconFileChange}
                                />
                                {iconPreview && (
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "4px",
                                        }}
                                    >
                                        <img
                                            src={iconPreview}
                                            alt="아이콘 미리보기"
                                            style={{
                                                width: "32px",
                                                height: "32px",
                                                objectFit: "contain",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                            }}
                                        />
                                        <button
                                            onClick={handleRemoveIcon}
                                            style={{
                                                background: "none",
                                                border: "none",
                                                cursor: "pointer",
                                                color: "red",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            X
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="modal-btn-box">
                        <div className={`modal-btn ${darkname}`} onClick={onSubmit}>
                            등록
                        </div>
                        <div
                            className={`modal-btn ${darkname}`}
                            onClick={() => setModal(false)}
                        >
                            취소
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function UpdateModal({ darkname, setModal, clickId, setReload }) {
    const [originalIcon] = useState(clickId.ti_icon || "");
    const [iconPreview, setIconPreview] = useState(clickId.ti_icon || "");
    const [iconFile, setIconFile] = useState(null);
    const hiddenFileInputRef = useRef(null);
    console.log(clickId)
    const [formData, setFormData] = useState({
        networkGroup: clickId?.ti_network ?? "",
        tokenName: clickId?.ti_name ?? "",
        tokenSymbol: clickId?.ti_symbol ?? "",
        tokenAddress: clickId?.ti_mintaddress ?? "",
        tokenDecimals: clickId?.ti_decimal ?? "",
        tokenDescription: clickId?.ti_description ?? "",
        tokenType: clickId?.ti_type || "coin",
        tokenIcon: clickId?.ti_icon ?? "",
    });

    const onChangeInput = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const onChangeSelect = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // "아이콘 업로드" 버튼 -> 숨겨진 file input 클릭
    const handleIconUploadClick = () => {
        if (hiddenFileInputRef.current) {
            hiddenFileInputRef.current.click();
        }
    };

    // 파일 선택 처리
    const handleIconFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setIconFile(file);
        // 새로 업로드한 파일 미리보기
        const previewUrl = URL.createObjectURL(file);
        setIconPreview(previewUrl);
        // formData.tokenIcon에도 파일명(또는 원하는 값) 세팅
        setFormData((prev) => ({ ...prev, tokenIcon: file.name }));
    };

    // X 버튼: 이미지 업로드 취소 -> 기존 이미지로 복원
    const handleRemoveIcon = () => {
        // file input도 리셋
        if (hiddenFileInputRef.current) {
            hiddenFileInputRef.current.value = "";
        }
        setIconFile(null);
        setIconPreview(originalIcon);
        setFormData((prev) => ({ ...prev, tokenIcon: originalIcon }));
    };

    const onSubmit = async () => {
        try {
            // 1) 토큰 이름 필수
            if (!formData.tokenName) {
                alert("토큰 이름(소문자)은 필수값입니다.");
                return;
            }
            // 2) 토큰 심볼 필수
            if (!formData.tokenSymbol) {
                alert("토큰 심볼(소문자)은 필수값입니다.");
                return;
            }
            // 3) tokenType === "token" 이면 토큰 주소 필수
            if (formData.tokenType === "token" && !formData.tokenAddress) {
                alert("토큰 타입이 token이면 토큰 주소가 필수값입니다.");
                return;
            }
            const decimalValue = Number(formData.tokenDecimals);
            if (!formData.tokenDecimals) {
                alert("토큰 소수점 자리수를 입력해 주세요.");
                return;
            }
            if (isNaN(decimalValue) || decimalValue <= 0 || !Number.isInteger(decimalValue)) {
                alert("토큰 소수점 자리수는 1 이상의 정수만 입력 가능합니다.");
                return;
            }

            const form = new FormData();
            form.append("id", clickId.no);
            form.append("ti_network", formData.networkGroup);
            form.append("ti_name", formData.tokenName);
            form.append("ti_symbol", formData.tokenSymbol);
            form.append("ti_mintaddress", formData.tokenAddress);
            form.append("ti_decimal", formData.tokenDecimals);
            form.append("ti_description", formData.tokenDescription);
            form.append("ti_type", formData.tokenType);

            if (iconFile) {
                form.append("file", iconFile);
            }

            const response = await axios.post(
                process.env.REACT_APP_API + "/api/wallet-token/update",
                form,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            const tmp = response.data;
            if (tmp?.code === 1000) {
                setModal(false);
                setReload((e) => !e);
            } else {
                alert(tmp?.msg || "수정에 실패했습니다.");
            }
        } catch (error) {
            console.log(error);
            alert("수정 중 오류가 발생했습니다.");
        }
    };

    return (
        <div className="modal">
            <div className="modal-box">
                <div className="modal-1" style={{ width: "500px" }}>
                    <div className="modal-1-header">토큰 수정</div>

                    <div style={{ marginBottom: "30px" }}>
                        {/* 네트워크 이름 (disabled) */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                네트워크 이름
                                <InfoIcon
                                    tooltipId="tooltip-networkGroup"
                                    content="토큰이 발행된 네트워크를 선택해 주세요"
                                />
                            </div>
                            <div className={`password-1 ${darkname}`} style={{ padding: "0" }}>
                                <select
                                    name="networkGroup"
                                    value={formData.networkGroup}
                                    onChange={onChangeSelect}
                                    disabled={true} // 수정 불가
                                    style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        padding: "7px 10px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <option value="solana">solana</option>
                                    <option value="bsc">bsc</option>
                                    <option value="ton">ton</option>
                                </select>
                            </div>
                        </div>

                        {/* 토큰 이름 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">토큰 이름</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenName"
                                    value={formData.tokenName}
                                    onChange={onChangeInput}
                                    placeholder="토큰 이름"
                                />
                            </div>
                        </div>

                        {/* 토큰 심볼 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                토큰 심볼
                                <InfoIcon
                                    tooltipId="tooltip-tokenSymbol"
                                    content="미니앱 지갑에서 표시되는 토큰의 심볼"
                                />
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenSymbol"
                                    value={formData.tokenSymbol}
                                    onChange={onChangeInput}
                                    placeholder="토큰 심볼"
                                />
                            </div>
                        </div>

                        {/* 토큰 주소 (tokenType==="coin" 이면 disabled) */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                토큰 주소
                                <InfoIcon
                                    tooltipId="tooltip-tokenAddress"
                                    content="토큰의 고유 주소입니다. (코인이면 비활성)"
                                />
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenAddress"
                                    value={formData.tokenAddress}
                                    onChange={onChangeInput}
                                    placeholder="토큰 주소"
                                    disabled={formData.tokenType === "coin"}
                                />
                            </div>
                        </div>

                        {/* 토큰 소수점 자리수 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                토큰 소수점 자리수
                                <InfoIcon
                                    tooltipId="tooltip-tokenDecimals"
                                    content="토큰의 소수점 자릿수를 입력하세요 (양의 정수)"
                                />
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenDecimals"
                                    value={formData.tokenDecimals}
                                    onChange={onChangeInput}
                                    placeholder="토큰 소수점 자리수"
                                />
                            </div>
                        </div>

                        {/* 토큰 설명 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">토큰 설명</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="tokenDescription"
                                    value={formData.tokenDescription}
                                    onChange={onChangeInput}
                                    placeholder="토큰 설명"
                                />
                            </div>
                        </div>

                        {/* 토큰 타입 (disabled) */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                토큰 타입
                                <InfoIcon
                                    tooltipId="tooltip-tokenType"
                                    content="네트워크 코인인지, 서브 토큰인지 선택 (coin/token)"
                                />
                            </div>
                            <div className={`password-1 ${darkname}`} style={{ padding: "0" }}>
                                <select
                                    name="tokenType"
                                    value={formData.tokenType}
                                    onChange={onChangeSelect}
                                    disabled={true}
                                    style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        padding: "7px 10px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <option value="coin">coin</option>
                                    <option value="token">token</option>
                                </select>
                            </div>
                        </div>

                        {/* 아이콘 업로드 & 미리보기 */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                토큰 아이콘
                                <InfoIcon
                                    tooltipId="tooltip-tokenIcon"
                                    content="토큰 로고 아이콘 이미지"
                                />
                            </div>
                            <div
                                className={`password-1 ${darkname}`}
                                style={{ display: "flex", alignItems: "center", gap: "8px" }}
                            >
                                <input
                                    name="tokenIcon"
                                    value={formData.tokenIcon}
                                    onChange={onChangeInput}
                                    placeholder="토큰 아이콘 URL"
                                    style={{ flex: 1 }}
                                />
                                {/* 업로드 버튼 */}
                                <div
                                    onClick={handleIconUploadClick}
                                    style={{
                                        backgroundColor: "#eee",
                                        borderRadius: "5px",
                                        padding: "5px 10px",
                                        cursor: "pointer",
                                    }}
                                >
                                    아이콘 업로드
                                </div>
                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={hiddenFileInputRef}
                                    style={{ display: "none" }}
                                    onChange={handleIconFileChange}
                                />

                                {/* 미리보기 */}
                                {iconPreview && (
                                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                        <img
                                            src={iconPreview}
                                            alt="아이콘 미리보기"
                                            style={{
                                                width: "32px",
                                                height: "32px",
                                                objectFit: "contain",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                            }}
                                        />
                                        {/* X 버튼: "새로 업로드했을 때만" 보임 */}
                                        {iconFile && (
                                            <button
                                                onClick={handleRemoveIcon}
                                                style={{
                                                    background: "none",
                                                    border: "none",
                                                    cursor: "pointer",
                                                    color: "red",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                X
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="modal-btn-box">
                        <div className={`modal-btn ${darkname}`} onClick={onSubmit}>
                            수정
                        </div>
                        <div className={`modal-btn ${darkname}`} onClick={() => setModal(false)}>
                            취소
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function InfoIcon({ content, tooltipId }) {
    // 재사용 툴팁 아이콘
    return (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span
                data-tooltip-id={tooltipId}
                data-tooltip-content={content}
                style={{ cursor: "pointer", fontSize: "16px" }}
            >
                <FontAwesomeIcon icon={faCircleInfo} style={{ color: "#b3b3b3" }} />
            </span>
            <Tooltip
                id={tooltipId}
                place="top"  // 툴팁 위치 (상단)
                effect="solid"
                style={{
                    backgroundColor: "#000",  // **완전한 흰색**
                    color: "#fff",  // 검은색 글씨
                    border: "1px solid gray",  // 회색 보더
                    padding: "8px",  // 내부 여백
                    borderRadius: "5px",  // 둥근 모서리
                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",  // 그림자 효과 추가
                    opacity: 1,  // **완전히 불투명하게 설정**
                    backdropFilter: "none", // 블러 효과 방지
                    WebkitBackdropFilter: "none" // 사파리 블러 방지
                }}
            />
        </div>
    );
}

export default Token;